/**
 * editor Constants
 * Centralized location for all editor configuration and styling constants
 */

// Font options available in the editor
export const FONTS = [
  'Arial',
  'Times New Roman',
  'Helvetica',
  'Georgia',
  'Verdana',
  'Calibri',
  'Trebuchet MS',
  'Comic Sans MS',
  'Huninn',
  'SBL Hebrew',
  'Ezra SIL',
  'Noto Sans Runic',
  'Noto Sans Cuneiform',
] as const

// Font size options
export const FONT_SIZES = ['8', '9', '10', '11', '12', '14', '15', '16', '18', '20', '22', '24', '28', '32', '36'] as const

// Text style options (headings, normal text) with keyboard shortcuts
export const TEXT_STYLES = [
  { label: 'Normal text', value: 'div', tag: 'div', shortcut: '⌘⌥0' },
  { label: 'Title', value: 'h1', tag: 'h1', shortcut: '⌘⌥1' },
  { label: 'Subtitle', value: 'h2', tag: 'h2', shortcut: '⌘⌥2' },
  { label: 'Heading 1', value: 'h3', tag: 'h3', shortcut: '⌘⌥3' },
  { label: 'Heading 2', value: 'h4', tag: 'h4', shortcut: '⌘⌥4' },
  { label: 'Heading 3', value: 'h5', tag: 'h5', shortcut: '⌘⌥5' },
] as const

